<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.name" :errors="$page.props.errors.name" class="mb-3" label="Naam" disabled />

        <label class="form-label mt-6">Toon in footer:</label>
        <select
            v-model="form.show_in_footer"
            class="form-input block appearance-none w-full py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
        >
            <option :value="false">Nee</option>
            <option :value="true">Ja</option>
        </select>


        <h2 class="font-bold text-xl mt-6 border-t pt-5">SEO teksten</h2>
        <textarea-input v-model="form.seo_description" :errors="$page.props.errors.seo_description" class="mb-3" label="Meta description" />
        <wysiwyg :value="form.seotext1" v-model="form.seotext1" :error="$page.props.errors.seotext1" label="SEO tekst boven"></wysiwyg>
        <wysiwyg :value="form.seotext2" v-model="form.seotext2" :error="$page.props.errors.seotext2" label="SEO tekst beneden"></wysiwyg>

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";
import wysiwyg from "@/admin/Shared/WYSIWYG";
import TextareaInput from "@/admin/Shared/TextareaInput";

export default {
    components: {
        TextInput,
        TextareaInput,
        wysiwyg
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        place: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    data() {
        return {
            form: {
                name: this.place.name || "",
                seotext1: this.place.seotext1 || "",
                seotext2: this.place.seotext2 || "",
                seo_description: this.place.seo_description || "",
                show_in_footer: this.place.show_in_footer
            }
        };
    },

    methods: {
        submit() {
            this.$emit("submit", this.form);
        }
    }
};
</script>
